import eranImage from 'assets/images/eran.png';
import noferImage from 'assets/images/nofer.png';
import ronanImage from 'assets/images/ronan.png';
import matchImage from 'assets/images/match.png';
import React from 'react';
import { GoogleReview } from '../DealRoomSection/GoogleReview';
import * as S from './DealRoomTestimonials.styles';

interface Testimonial {
  name: string;
  feedback: string;
  avatarUrl: string;
}

const testimonials: Testimonial[] = [
  {
    name: 'ערן‭ ‬אליהו',
    avatarUrl: eranImage,
    feedback: `שבת לפנות בוקר ארון חשמל נשרף. עם חברה אחרת כנראה שלא היה עם מי לדבר. בשעה 06:00 בבוקר יצרתי קשר, תוך שעה-שעה וחצי כבר הגיעו לטפל ולסגור את כל העניינים והאופרציה.
השירות הוא מעל הכול בחברת בר-עוז וזה הדגש שלהם, זמינות ושירות. זה כנראה מה שמוביל אותם להיות מספר אחד בתחום.`,
  },
  {
    name: 'נופר‭ ‬אלפסי',
    avatarUrl: noferImage,
    feedback: `בבר‭-‬עוז‭ ‬יש‭ ‬צוות‭ ‬מאוד‭ ‬מאוד‭ ‬מקצועי‭ ‬שזמין‭ ‬כל‭ ‬הזמן‭ ‬ונותן‭ ‬מענה‭. ‬ ככה‭ ‬מקבלים‭ ‬כיסוי‭ ‬מקסימלי‭ ‬עבור‭ ‬הבניין‭. ‬הם‭ ‬נותנים‭ ‬לנו‭ ‬מעטפת‭ ‬כל‭ ‬כך‭ ‬רחבה‭ ‬של‭ ‬דאגה‭, ‬הייתה‭ ‬לנו‭ ‬שריפה‭ ‬בבניין‭ ‬שקיבל‭ ‬החזר‭ ‬של‭ ‬2,500,000‭ ‬₪‭.‬`,
  },
  {
    name: 'רונן דנון',
    avatarUrl: ronanImage,
    feedback: `זו‭ ‬לא‭ ‬המלצה‭ ‬מבחינתי‭, ‬זו‭ ‬חובה‭ - ‬אין‭ ‬דרך‭ ‬אחרת‭ ‬לעבוד‭ ‬עם‭ ‬חברת‭ ‬ביטוח‭ ‬ולא‭ ‬עם‭ ‬בר‭-‬עוז‭, ‬כי‭ ‬הם‭ ‬באמת‭ ‬נותנים‭ ‬שקט‭. ‬הם‭ ‬תמיד‭ ‬מחפשים‭ ‬איך‭ ‬לעזור‭ ‬מעבר‭, ‬דבר‭ ‬שהוא‭ ‬נדיר‭.‬`,
  },
  {
    name: 'רשבי מושלם',
    avatarUrl: matchImage,
    feedback:
      'אין‭ ‬ספק‭, ‬בר‭-‬עוז‭ ‬לקחו‭ ‬את‭ ‬המקצוע‭ ‬הזה‭ ‬עד‭ ‬הסוף‭. ‬לכן‭ ‬הם‭ ‬הכי‭ ‬גדולים‭ ‬והכי‭ ‬טובים‭. ‬כמה‭ ‬שהם‭ ‬גדלו‭ ‬הם‭ ‬עדיין‭ ‬הכי‭ ‬טובים‭, ‬עדיין‭ ‬נותנים‭ ‬את‭ ‬השירות‭ ‬הכי‭ ‬טוב‭ ‬והמענה‭ ‬לכל‭ ‬הנדרש‭. ‬אתה‭ ‬צריך‭ ‬שירות‭ ‬ושמישהו‭ ‬יענה‭ ‬לך‭ ‬בזמן‭ ‬ויתן‭ ‬לך‭ ‬את‭ ‬הגב‭ ‬מול‭ ‬חברות‭ ‬הביטוח‭. ‬וצריך‭ ‬הרבה‭ ‬גב‭ ‬מולם‭!!!‬',
  },
];

const DealRoomTestimonials: React.FC = () => {
  return (
    <S.ListWrapper>
      {testimonials.map((t, idx) => (
        <S.CardWrapper key={idx}>
          <S.CardContent>
            <S.CardImageWrapper>
              <img src={t.avatarUrl} />
            </S.CardImageWrapper>
            <S.UserInfo>
              <S.UserName>{t.name}</S.UserName>
              <S.FeedbackText>
                <S.FeedbackTextQuote>{t.feedback}</S.FeedbackTextQuote>
              </S.FeedbackText>
            </S.UserInfo>
          </S.CardContent>
        </S.CardWrapper>
      ))}
      <GoogleReview />
    </S.ListWrapper>
  );
};

export default DealRoomTestimonials;
